module.exports = __webpack_public_path__ + "img/0132.be213275.png";